<template>
  <div class="empty-bd">
    <div class="empty-wrap">
      <div class="img-box">
        <img src="../../images/svg/nodata.png" alt="">
      </div>
      <slot>
        <p>{{text}}</p>
      </slot>
    </div>
  </div>
</template>
<script>
/**
 * <t-empty text="没有更多订单"> </t-empty>
 *
 */
export default {
  name: 'tEmpty',
  props: {
    text: { type: String, default: '暂无数据' },
  },
  data() {
    return {};
  },
  mounted: function () {},
  methods: {},
};

</script>
<style lang="scss">
.empty-bd {
  padding: 80px 0;
  .img-box {
    width: 48%;
    margin: auto;
    img {
      display: block;
      width: 100%;
    }
  }
  p {
    text-align: center;
    font-size: 0.13rem;
    line-height: 0.2rem;
    margin-top: 0.08rem;
    color: #9C9C9C;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/custom/empty.vue